// Campos do laudo de calibracao de INCUBADORA de indicador biologico.
// Para mudar esse formulario, mexa so neste arquivo.
const incubadora = {
  titulo: 'Incubadora',
  leituras: 'incubadora',
  pontosPadrao: [{ tempo: '10 min' }, { tempo: '40 min' }, { tempo: '1 h' }, { tempo: '2 h' }, { tempo: '4 h' }],
  secoes: [
    {
      titulo: 'Identificação do equipamento',
      campos: [
        { n: 'tag', l: 'TAG', t: 'texto', span: 4, up: true, ajuda: 'Identificação da incubadora dentro do cliente. Ex.: INC-01.' },
        { n: 'marca', l: 'Marca', t: 'texto', span: 5, ajuda: 'Fabricante da incubadora. Em branco sai NÃO CONSTA no laudo.' },
        { n: 'modelo', l: 'Modelo', t: 'texto', span: 5, ajuda: 'Modelo do fabricante, quando houver.' },
        { n: 'numero_serie', l: 'Nº de série', t: 'texto', span: 5, ajuda: 'Número de série da incubadora.' },
        { n: 'marca_indicador', l: 'Indicador biológico', t: 'texto', span: 5, ajuda: 'Marca e modelo do indicador usado. É o que justifica a faixa de temperatura adotada no laudo. Ex.: 3M Attest 1262.' },
        { n: 'local_instalacao', l: 'Local de instalação', t: 'texto', span: 6, up: true, ajuda: 'Onde a incubadora fica no cliente. Ex.: sala de esterilização.' },
        { n: 'validade_anos', l: 'Validade', t: 'sel', span: 3, ajuda: 'De quanto em quanto tempo a incubadora deve ser recalibrada.',
          o: [[1, '1 ano'], [2, '2 anos'], [3, '3 anos'], [4, '4 anos'], [5, '5 anos']] },
        { n: 'data_calibracao', l: 'Data', t: 'data', span: 4, ajuda: 'Data em que a calibração foi executada.' }
      ]
    },
    {
      titulo: 'Ensaio',
      campos: [
        { n: 'temp_min', l: 'Faixa do fabricante — mínima (°C)', t: 'num', span: 5,
          ajuda: 'Menor temperatura da faixa que o fabricante do indicador biológico informa. Ex.: 55 para um indicador de 55 a 60 °C.' },
        { n: 'temp_max', l: 'Faixa do fabricante — máxima (°C)', t: 'num', span: 5,
          ajuda: 'Maior temperatura da faixa do fabricante. O laudo aceita essa faixa com 2 °C de folga para cada lado.' },
        { n: '_faixa', l: 'Faixa aceita no laudo', t: 'calc', span: 5,
          ajuda: 'Faixa do fabricante com a tolerância de 2 °C para mais e para menos. É contra ela que cada leitura é avaliada.',
          calc: (v) => (v.temp_min != null && v.temp_max != null)
            ? String(Number(v.temp_min) - 2).replace('.', ',') + ' a ' + String(Number(v.temp_max) + 2).replace('.', ',') + ' °C' : '' },
        { n: 'tempo_aquecimento', l: 'Tempo até estabilizar (min)', t: 'num', span: 4,
          ajuda: 'Quantos minutos a incubadora levou, ligada do zero, para estabilizar na temperatura de trabalho.' },
        { n: 'temp_ambiente', l: 'Temperatura ambiente', t: 'texto', span: 4, ajuda: 'Temperatura da sala durante o ensaio, com a tolerância.' },
        { n: 'umidade', l: 'Umidade do ar', t: 'texto', span: 3, ajuda: 'Umidade da sala durante o ensaio, com a tolerância.' }
      ]
    }
  ],
  pontos: {
    ajuda: 'Cada linha é uma leitura ao longo do ensaio. A primeira linha é o aquecimento: ela aparece no laudo, mas não entra na média nem na avaliação. Os tempos sugeridos podem ser alterados.',
    colunas: [
      { n: 'tempo', l: 'Tempo', t: 'texto', ajuda: 'Momento da leitura contado do início. Ex.: 10 min, 1 h, 4 h.' },
      { n: 'padrao', l: 'Temp. do padrão (°C)', ajuda: 'Temperatura medida pelo sensor padrão dentro da câmara. É ela que decide a aprovação.' }
    ]
  },
  fechamento: [
    { n: 'fator_k', l: 'Fator k', t: 'sel', span: 4, o: [[2, '2 (95%)'], [3, '3 (99%)']],
      ajuda: 'Multiplicador da incerteza padrão para chegar na incerteza expandida. k = 2 corresponde a cerca de 95% de confiança.' },
    { n: 'danificado', l: 'Danificada?', t: 'bool', span: 4, ajuda: 'Marque se a incubadora chegou com dano que impeça o uso.' },
    { n: 'substituido', l: 'Substituída?', t: 'bool', span: 4, ajuda: 'Marque se a incubadora foi trocada por outra no atendimento.' }
  ]
};

export default incubadora;
